<template>
    <!-- TODO wrap this into the animation wrapper -->
    <div v-bind="$attrs" :class="galleryItemClasses">
        <MockupContainer
            v-if="galleryItem.media.mockupSettings"
            :media="galleryItem.media"
            :scrollable="allowMockupScroll"
            :show-scroll-hint="showScrollHint"
            :scroll-hint-section-key="scrollHintSectionKey"
            :scroll-hint-priority="scrollHintPriority"
        />
        <div v-else class="mockup-display">
            <div class="mockup-image">
                <div class="ufo-mockup--scroller slider-image-container">
                    <img
                        ref="img"
                        v-zoomable="isImageZoomable"
                        :alt="galleryItem.media?.altTag || 'Screen design displayed in a mockup'"
                        :fetchpriority="imageFetchPriority"
                        :height="galleryItem.media?.height"
                        :loading="imageLoadingStrategy"
                        :src="getImageUrl"
                        :style="[cornerRadiusStyle, { '--aspect-ratio': normalizedAspectRatio }]"
                        :width="galleryItem.media?.width"
                        @load="imageLoaded"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MockupContainer from "@/scripts/common/components/MockupContainer.vue";
    import {GalleryLayout, SectionTypesEnum} from "@/scripts/common/enums.js";

    export default {
        name: "GetGalleryMediaContent",
        components: {MockupContainer},
        props:['section', 'galleryItem', 'index', 'imageStyles', 'scrollHintPriority', 'scrollHintSectionKey', 'isPreview'],
        data() {
            return {
                L: GalleryLayout,
            }
        },
        methods: {
            imageLoaded() {
                this.$store.commit("recalculateScrollTriggers");
            },
        },
        computed: {
            galleryLayout() {
                return this.section?.layout;
            },
            galleryItemClasses() {
                return [
                    'gallery-item',
                    this.galleryItem.media?.mockupSettings?.deviceType || 'no-mockup'
                ];
            },
            imageLoadingStrategy() {
                if (this.galleryLayout === this.L.TILTED) {
                    return null;
                }

                return this.shouldPrioritizeCarouselImage ? "eager" : "lazy";
            },
            imageFetchPriority() {
                return this.shouldPrioritizeCarouselImage ? "high" : null;
            },
            shouldPrioritizeCarouselImage() {
                if (this.galleryLayout !== this.L.CAROUSEL) {
                    return false;
                }

                const itemCount = this.section?.galleryItems?.length || 0;
                if (itemCount <= 1) {
                    return true;
                }

                const prioritizedIndexes = new Set([
                    0,
                    1,
                    itemCount - 1,
                    itemCount - 2
                ].filter((value) => value >= 0 && value < itemCount));

                return prioritizedIndexes.has(this.index);
            },
            isImageZoomable() {
                return !this.isPreview
                    && this.galleryItem.type !== 'MainHeader'
                    && this.galleryLayout !== this.L.TILTED
                    && (!this.galleryItem.media.displayMode || this.galleryItem.media.displayMode && this.galleryItem.media.displayMode !== 'full')
                    && !this.galleryItem.media.mockupSettings
            },
            getImageUrl() {
                return this.galleryItem.media?.croppedImageUrl || this.galleryItem.media?.url
            },
            cornerRadiusStyle() {
                if (this.galleryItem.media?.mockupSettings) {
                    return null;
                }
                return { borderRadius: `${this.imageStyles?.cornerRadius}px` };
            },
            normalizedAspectRatio() {
                if (!this.imageStyles?.aspectRatio || this.galleryItem.media.mockupSettings) return null;
                return this.imageStyles.aspectRatio.replace("_", "/").toLowerCase();
            },
            allowMockupScroll() {
                if (this.isPreview) return false;

                if (this.section.type === SectionTypesEnum.GALLERY) {
                    return this.section.allowScrollInMockup !== false;
                }
                return true;
            },
            showScrollHint() {
                return !this.isPreview && this.allowMockupScroll && (this.section?.hintThatMockupScrolls ?? true);
            }
        }
    }
</script>
